import { render } from "./TheCapDonVi.vue?vue&type=template&id=04674a88"
import script from "./TheCapDonVi.vue?vue&type=script&lang=js"
export * from "./TheCapDonVi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__